export default {"src":"/_next/static/media/bgLight.c2a463c3.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};